import { render, staticRenderFns } from "./topBanner.vue?vue&type=template&id=37d078ee&scoped=true"
import script from "./topBanner.vue?vue&type=script&lang=js"
export * from "./topBanner.vue?vue&type=script&lang=js"
import style0 from "./topBanner.vue?vue&type=style&index=0&id=37d078ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d078ee",
  null
  
)

export default component.exports